import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import Section, { Row, Col, Box } from '../../../../components/ui/wrapper'
import Heading from '../../../../components/ui/heading'
import Text from '../../../../components/ui/text'
import Image from '../../../../components/image'
import Ratings from '../../../../components/ratings'
import BoxIcon from '../../../../components/box-icon/layout-four'
import Anchor from '../../../../components/ui/anchor'
import Button from "../../../../components/ui/button";
import { Link } from 'gatsby';

const ContactArea = ({ sectionStyle, imgBoxStyle, rightBoxStyle, boxIconStyle, ratinStyle, textStyle, btnStyle }) => {
    const contactData = useStaticQuery(graphql`query AboutContactQuery {
  info: site {
    siteMetadata {
      contact {
        phone
        email
        rating
        customers
        clients
      }
    }
  }
  bgImage: file(relativePath: {eq: "images/bg/contact-bg.jpg"}) {
    childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, quality: 70, placeholder: BLURRED)
    }
  }
  contactImg: file(relativePath: {eq: "images/about-us/contact.jpg"}) {
    childImageSharp {
      gatsbyImageData(
        height: 572
        width: 587
        quality: 75
        placeholder: BLURRED
        layout: CONSTRAINED
      )
    }
  }
}
`)
    const { phone, email, rating, customers, clients } = contactData.info.siteMetadata.contact;
    const bg_image = contactData.bgImage.childImageSharp.gatsbyImageData;
    const contact_image = contactData.contactImg.childImageSharp.gatsbyImageData;

    return (
        <Section {...sectionStyle} bgImage={bg_image}>
            <Row alignitems="center">
                <Col lg={7}>
                    <Box {...imgBoxStyle}>
                        <Image image={contact_image} alt="Contact Us" />
                    </Box>
                </Col>
                <Col lg={4} ml="auto">
                    <Box {...rightBoxStyle}>
                        <Box textalign="center">
                            <Heading as="h3">Let's Work <span style={{ color: "#4b1e79" }}>Together</span></Heading>
                            <Button
                                to="/free-consultation"
                                as={Link}
                                {...btnStyle}
                            >
                                Start A Conversation
                            </Button>
                        </Box>
                        {/* <Box textalign="center">
                            {rating && <Heading as="h3">{`${rating}/5.0`}</Heading>}
                            <Ratings {...ratinStyle} rating={+rating}/>
                            <Text {...textStyle}>by {customers}+ customers for {clients}+ clients</Text>
                        </Box> */}
                        <Box>
                            {/* <Anchor display="block" path={`tel:${phone}`}>
                                <BoxIcon
                                    {...boxIconStyle}
                                    icon="fal fa-phone"
                                    heading="Call for advice now!"
                                    title={phone}
                                />
                            </Anchor> */}
                            <Anchor display="block" path={`mailto:${email}`}>
                                <BoxIcon
                                    {...boxIconStyle}
                                    icon="fal fa-envelope"
                                    heading="Say hello"
                                    title={email}
                                />
                            </Anchor>
                        </Box>
                    </Box>
                </Col>
            </Row>
        </Section>
    )
}

ContactArea.propTypes = {
    sectionStyle: PropTypes.object
}

ContactArea.defaultProps = {
    sectionStyle: {
        pt: '100px',
        bgColor: '#eff2f6',
        responsive: {
            medium: {
                pt: "75px"
            }
        }
    },
    imgBoxStyle: {
        responsive: {
            medium: {
                mb: "57px"
            }
        }
    },
    rightBoxStyle: {
        responsive: {
            medium: {
                mb: "45px"
            }
        }
    },
    boxIconStyle: {
        wrapperStyle: {
            alignitems: 'center',
            mt: '55px'
        },
        iconStyle: {
            fontSize: '40px',
            mr: "25px",
            fontweight: 300
        },
        titleStyle: {
            fontSize: '34px',
            mb: "0",
            fontweight: 700,
            lineHeight: 1.17,
            responsive: {
                large: {
                    fontSize: "24px"
                }
            }
        }
    },
    ratinStyle: {
        mt: '10px',
        mb: '10px'
    },
    textStyle: {
        fontSize: '18px'
    },
    btnStyle: {
        mt: "20px",
        skin: "secondary",
        minwidth: "230px",
        hover: {
            bgColor: "primary"
        }
    }
}

export default ContactArea;